import { render, staticRenderFns } from "./github-signin.vue?vue&type=template&id=c07e6670&scoped=true&"
import script from "./github-signin.vue?vue&type=script&lang=ts&"
export * from "./github-signin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07e6670",
  null
  
)

export default component.exports